<template>
  <div class="-cell-label" :class="this.cellClassName" :style="widthStyle">
    <span ref="label" style='display: block' :title="label"> {{ label }}</span>
  </div>
</template>

<script>
/**
 * 이름 : CellNumberLabel
 * 설명 : 그리드용 NumberLabel
 * 최종 수정 일시 : 2019 - 12 - 23
 */
export default {
  name: 'CellNumberLabel',
  props: {
    value: { type: [String, Object], default: '' },
    width: { type: String, default: '' },
    decimalCount: { type: Number, default: -1 },
    cellClassName: { type: String, default: '' },
  },
  data() {
    return {
      realValue: this.value,
      label: utils.numberFormat(this.value, this.decimalCount),
    };
  },
  computed: {
    widthStyle() {
      if (this.width !== '') { return { width: this.width }; }
      return '';
    },
  },
  watch: {
    value() {
      this.setValue(this.value);
    },
  },
  methods: {
    setValue(value) {
      this.realValue = value;
      this.setDefaultValue();
    },
    setDefaultValue() {
      this.label = utils.numberFormat(this.realValue, this.decimalCount);
    },
    getValue() {
      return this.realValue;
    },
  },
};

</script>
<style scoped>
</style>
